import { useEffect, useState } from "react";
import { http } from "./api";

export const CATEGORIES = ["Technical articles", "Trial results", "Exhibitions & events", "Company news"];

export const formatDate = (d) => {
  const dt = new Date(d);
  return isNaN(dt) ? d : dt.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
};

export const usePosts = (category) => {
  const [posts, setPosts] = useState(null);
  useEffect(() => {
    let alive = true;
    http.get("/posts", { params: category ? { category } : {} })
      .then((r) => { if (alive) setPosts(Array.isArray(r.data) ? r.data : []); })
      .catch(() => { if (alive) setPosts([]); });
    return () => { alive = false; };
  }, [category]);
  return posts;
};
